function baseButton(bgColor: string) {
  return {
    padding: 10,
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 600,
    backgroundColor: bgColor,
    color: '#fff',
    fontSize: 14,
    transition: 'all 0.2s ease',
    width: '100%',
  };
}

export const styles = {
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: 16,
  } as React.CSSProperties,
  modal: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 12,
    position: 'relative',
    width: '100%',
    maxWidth: 500,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    maxHeight: '90vh',
    overflowY: 'auto',
  } as React.CSSProperties,

  timeActionButtons: {
    display: 'flex',
    gap: '21px',
    marginTop: '10px',
    marginLeft: '69px',
    flexWrap: 'wrap' as const,
  },

  secondaryButton: {
    backgroundColor: '#e0e0e0',
    color: '#333',
    border: '1px solid #ccc',
    padding: '5px 10px',
    borderRadius: '3px',
    cursor: 'pointer',
    fontSize: '12px',
  },

  secondaryButtonDisabled: {
    backgroundColor: '#f5f5f5',
    color: '#999',
    border: '1px solid #ddd',
    padding: '5px 10px',
    borderRadius: '3px',
    cursor: 'not-allowed',
    fontSize: '12px',
  },

  modalTitle: {
    margin: 0,
    marginBottom: 16,
    color: '#333',
    fontSize: 18,
    fontWeight: 600,
  } as React.CSSProperties,
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 16,
  } as React.CSSProperties,
  cleanButton: {
    ...baseButton('#0f77ff'),
  },
  unselectedButton: {
    ...baseButton('#ddd'),
  },
  presentButton: {
    ...baseButton('#4CAF50'),
  },
  absentButton: {
    ...baseButton('#f44336'),
  },
  vacationButton: {
    ...baseButton('#df9610ff'),
  },

  timeContainer: {
    margin: '12px 0',
    padding: 12,
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
  },
  timeInputContainer: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    marginBottom: 10,
    width: '100%',
  },
  timeLabel: {
    fontSize: 13,
    color: '#555',
    fontWeight: 500,
    minWidth: 60,
  },
  timeInput: {
    flex: 1,
    padding: 10,
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    backgroundColor: '#fff',
    fontSize: 14,
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  },
  reasonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 12,
  } as React.CSSProperties,
  textarea: {
    width: '100%',
    padding: 10,
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    resize: 'vertical',
    minHeight: 80,
    fontSize: 14,
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  } as React.CSSProperties,
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
  },
  cancelButton: {
    backgroundColor: 'transparent',
    color: '#6c757d',
    padding: '8px 12px',
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: 13,
  },
  confirmButton: {
    backgroundColor: '#2196F3',
    color: '#fff',
    padding: '8px 16px',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: 13,
  },
  toggleButton: {
    backgroundColor: 'transparent',
    color: '#2196F3',
    padding: '6px 10px',
    border: '1px solid #e0e0e0',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 10,
    width: '100%',
  },
};
